export const ROUTES = {
    DASHBOARD: '/documents'
}